<template>
  <div>
    <div class="container-md plr-0">
      <div class="container-bg p-4 pright-g">
        <div
          class="d-flex itmg-tit-wrap"
          style="justify-content: space-between"
        >
          <h3 class="list-h3">ALLE COMMISSIES</h3>
          <div>
            <router-link
              to="/settings/create/committee"
              class="btn btn-dark btn-sm mr-3 list-btn"
              >Nieuwe commissie</router-link
            >
          </div>
        </div>
        <div class="row mt-5">
          <div
            class="col-12 ml-auto d-flex"
            style="justify-content: space-between"
          >
            <form action="" class="form-inline ml-auto row mr-3">
              <div class="form-group col-9">
                <input
                  v-model="title"
                  type="text"
                  class="form-control"
                  placeholder="Zoeken"
                />
              </div>
              <div class="form-group col-2">
                <button
                  type="button"
                  @click="search()"
                  class="btn btn-dark btn-sm"
                >
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="row" style="height: 600px; overflow: auto">
          <div class="col-md-12">
            <a
              v-for="committee in committees"
              :key="'group_' + committee.id"
              :href="'/settings/committee/' + committee.id"
              class="
                flex-container
                collapsed
                w-100
                flex-body
                mt-3
                d-flex
                group-item
              "
              style="justify-content: space-between"
            >
              <div class="item text-center d-flex w-100 pl-2">
                <i class="fas fa-bars text-white mt-1"></i>
                <div class="item group-name text-white">
                  {{ committee.title }}
                </div>
              </div>
              <div class="item text-white text-right pr-3">
                <a
                  href="javascript:void(0)"
                  @click="deleteGroup(committee.id, $event)"
                  class="action-btn text-white"
                  ><i class="fa fa-trash"></i
                ></a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      committees: [],
      title: "",
    };
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    deleteGroup(id, e) {
      e.stopPropagation();

      this.$swal
        .fire({
          text: "Weet je zeker dat je deze commissie wilt verwijderen?",
          showDenyButton: true,
          confirmButtonText: "Ja",
          denyButtonText: `Nee`,
          denyButtonColor: "#aaa",
          confirmButtonColor: "#3085d6",
          width: "30em",
        })
        .then((result) => {
          if (result.isConfirmed) {
            var temp = [...this.committees];
            temp = temp.filter((d) => d.id != id);
            this.committees = [...temp];
            this.$store.dispatch("delete", "api/v1/committees/" + id);
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              text: "Delete successfully",
              showConfirmButton: false,
              timer: 1000,
              width: "10em",
            });
          }
        });
    },
    search() {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/committees/search/3",
          details: { search: [{ attribute: "title", value: this.title }] },
        })
        .then((data) => {
          console.log(data);
          this.committees = data.data.data;
        });
    },
  },
  created() {
    this.$store
      .dispatch("get", "api/v1/committees/parent_id/3")
      .then((data) => {
        this.committees = data.data.data;
      });
  },
};
</script>
<style scoped>
.card-body {
  background: transparent;
  border: none;
  padding: 0px 0px 0px 30px;
}
.card-body .group-item {
  margin-top: 5px !important;
}
.group-item .fa-chevron-right {
  transform: rotate(90deg);
}
.group-item.collapsed .fa-chevron-right {
  transform: rotate(0deg);
}
.group-item {
  text-decoration: none;
}
.action-btn {
  font-size: 13px;
  margin-right: 5px;
}
.group-name {
  font-size: 12px;
  text-align: left;
  margin-left: 10px !important;
}
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #515251;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 5px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 2px 0;
  width: auto;
}
</style>
